<template>
  <page-outline :title="pageTitle">
    <template slot="pageContent">
      <b-row class="justify-content-start mb-5">
        <b-col cols="4" lg="2" xl="1">
          <back-button :returnUrl="returnUrl"></back-button>
        </b-col>
      </b-row>
      <spinner v-if="activateSpinner"></spinner>
      <bic-group-form :mode="mode" :readonly="!isEditable" v-model="config" v-else></bic-group-form>
      <b-row class="justify-content-end">
        <b-col cols="4" lg="2" xl="1" v-if="isEditable && formType !== 'add'">
          <b-button variant="primary"
            @click="switchMode('details')">
            <span>{{ $t('common.cncl') }}</span>
          </b-button>
        </b-col>
        <b-col cols="4" lg="2" xl="1" v-if="!isEditable && formType !== 'add'">
          <b-button variant="primary"
            @click="switchMode('edit')">
            <i class="fa-light fa-pencil"></i>
            <span>{{ $t('administration.edit') }}</span>
          </b-button>
        </b-col>
        <b-col cols="4" lg="2" xl="1" v-if="!isEditable && formType !== 'add'">
          <b-button variant="primary"
            @click="deleteBic">
            <i class="fa-light fa-trash"></i>
            <span>{{ $t('rights.delete') }}</span>
          </b-button>
        </b-col>
        <b-col cols="4" lg="2" xl="1" v-if="isEditable && formType !== 'add'">
          <b-button variant="primary"
            @click="editBic">
            <i class="fa-light fa-save"></i>
            <span>{{$t('common.sve')}}</span>
          </b-button>
        </b-col>
        <b-col cols="4" lg="2" xl="1" v-if="mode === 'add'">
          <b-button variant="primary"
            @click="addBic">
            <i class="fa-light fa-save"></i>
            <span>{{$t('common.sve')}}</span>
          </b-button>
        </b-col>
      </b-row>
    </template>
  </page-outline>
</template>

<script>
import formReadGroupLabelInput from '@/components/common/formReadGroupLabelInput.vue'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import PageOutline from '@/components/common/PageOutline.vue'
import {errorMessageAlert} from '@/helpers/alert'
import backButton from "@/components/common/backButton.vue"
import Spinner from '@/components/common/spinner.vue'
import BicGroupForm from '@/pages/bic/BicGroupForm.vue'
import {loadPage} from '@/helpers/routing'

export default {
  name: "BicGroupDetails",
  components: {
    'back-button': backButton,
    'bic-group-form': BicGroupForm,
    'form-read-group-label-input': formReadGroupLabelInput,
    'form-write-group-label-input': formWriteGroupLabelInput,
    'page-outline': PageOutline,
    'spinner': Spinner
  },
  props: {
    mode: {
      type: String,
      default: "add"
    },
    id: {
      type: String,
      default: '-1'
    }
  },
  computed: {
    isEditable () {
      return this.formType === 'add' || this.formType === 'edit'
    },
    pageTitle() {
      switch (this.mode) {
        case 'edit':
          return this.$t('Webheader.bic_group_edit');
        case 'details':
          return this.$t('Webheader.bic_group_details');
        case 'add':
        default:
          return this.$t('Webheader.bic_group_add');
      }
    }
  },
  data() {
    return {
      activateSpinner: false,
      bic: '',
      returnUrl: '',
      currentBicGroup: {},
      savedConfig: [],
      config: {},
      originalConfig: {},
      formType: 'add'
    }
  },
  created() {
    this.activateSpinner = true
    this.formType = this.mode

    this.returnUrl = 'bic/bicGroup/-1'

    if(this.id !== '-1' && (this.mode === "details" || "edit")) {
      this.getBicGroup()
    } else {
      this.activateSpinner = false
    }
  },
  methods: {
    addBic () {
      let that = this

      if (this.formHasError()) {
        return
      }

      let params = {
        GroupName: this.config.GroupName,
        id: this.id
      }
      this.$engine.bic.bicGroup.create(params)
      .then(resp => {
        that.$f7.modal({
          title: that.$t('common.bic.bic_group_added'),
          buttons: [
            {
              text: 'OK',
              onClick: function () {
                return
              }
            }
          ]
        })
        loadPage(that, {url: 'bic/bicGroup/-1'})
      })
      .catch(e => {
        errorMessageAlert(e, that)
        that.okMessageBox(that.$t('common.bic.bic_group_addition_error'))
      })
    },
    deleteBic () {
      let that = this
      this.$f7.modal({
        title: this.$t('common.bic.element_deletion_confirm'),
        buttons: [
          {
            text: this.$t('creation_forms.vldt'),
            onClick: function () {
              let params = {
                IdBicGroup: that.id
              }
              that.$engine.bic.bicGroup.delete(params)
              .then(resp => {
                that.$f7.modal({
                  title: that.$t('common.bic.bic_group_deleted'),
                  buttons: [
                    { text: 'OK', onClick: function () { return } }
                  ]
                })
                loadPage(that, {url: 'bic/bicGroup/-1' })
              })
              .catch(e => {
                errorMessageAlert(e, that, that.$i18n)
                that.okMessageBox(that.$t('common.bic.bic_group_delete_error'))
              })
            }
          },
          {
            text: this.$t('common.cncl'),
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    editBic () {
      let that = this
      let params = {
        GroupName: this.config.GroupName,
        IdBicGroup: this.id
      }
      this.$engine.bic.bicGroup.edit(params)
      .then(resp => {
        that.$f7.modal({
          title: that.$t('common.bic.bic_group_edited'),
          buttons: [
            {
              text: 'OK',
              onClick: function () {
                return
              }
            }
          ]
        })
        loadPage(that, {url: 'bic/bicGroup/-1' })
      })
      .catch(e => {
        errorMessageAlert(e, that)
        that.okMessageBox(that.$t('common.bic.bic_edition_error'))
      })
    },
    fillFields () {
      this.config = this.currentBicGroup
      this.originalConfig = this.currentBicGroup
      this.activateSpinner = false
    },
    formHasError () {
      if (this.config.GroupName === undefined || this.config.length === 0) {
        this.okMessageBox(this.$t('common.bic.bic_group_name_missing'))
        return true
      }
      return false
    },
    getBicGroup () {
      let that = this
      this.$engine.bic.bicGroup.fetch({id: this.id})
      .then(resp => {
        let bicGroupList = {}

        bicGroupList = resp.data.BicGroup
        that.updateBic(bicGroupList)
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    okMessageBox (message) {
      this.$f7.modal({
        title: message,
        buttons: [
          {
            text: 'OK',
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    switchMode (mode) {
      if (mode === 'details' && this.formType === 'edit') {
        this.config = this.originalConfig
      }
      this.formType = mode
    },
    updateBic(bicGroupList){
      const selectedBic = bicGroupList.find(bicGroup => bicGroup.IdBicGroup === this.id)
      this.currentBicGroup = selectedBic
      this.fillFields()
    }
  }
}
</script>
